import { invariant } from './invariant'

export class TrackStrategyRegistry {
  /**
   * @type {Map<string, import('./track-strategy').TrackStrategy>}
   * @private
   */
  _strategies = new Map()

  /**
   * @param {string} eventType - The type of the event.
   * @param {import('./track-strategy').TrackStrategy} strategy - The tracking strategy to register.
   * @returns {void}
   */
  register(eventType, strategy) {
    this._strategies.set(eventType, strategy)
  }

  /**
   * @param {string} eventType - The type of the event.
   * @returns {import('./track-strategy').TrackStrategy} The tracking strategy registered for the given event type.
   * @throws {Error} Throws an error if no strategy is registered for the given event type.
   */
  retrieve(eventType) {
    invariant(
      this._strategies.has(eventType),
      `No strategy registered for event type: ${eventType}`,
    )
    return this._strategies.get(eventType)
  }
}
